import _classCallCheck from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import { jsxs as e, jsx as r } from "react/jsx-runtime";
import { calculateRem as t, withVDSManager as o, checkIfMobileDevice as n, generateUUID as a, getNodeText as i } from "@vds-core/utilities";
import { AccessibilityTokens as s } from "@vds-tokens/accessibility";
import { ColorTokens as d } from "@vds-tokens/color";
import { FormControlsTokens as l } from "@vds-tokens/form-controls";
import { LayoutTokens as c } from "@vds-tokens/layout";
import { TypographyTokens as u } from "@vds-tokens/typography";
import { Component as p } from "react";
import h from "styled-components";
import v from "../utils/showError.js";
import f from "./RadioButtonLabel.js";
var b = d.interactive.disabled.onlight.value,
  m = d.interactive.disabled.ondark.value,
  k = c.space["3X"].value,
  g = s.focusring.space.offset.value,
  $ = s.focusring.borderwidth.value,
  y = s.focusring.borderstyle.value,
  w = "calc(100% + ".concat(t(2 * (parseInt(g, 10) + parseInt($, 10))), ")"),
  _ = function _() {
    return t(u.letterspacing.wide.value);
  },
  x = function x(e) {
    return "dark" === e ? d.feedback.error.ondark.value : d.feedback.error.onlight.value;
  },
  C = function C(e, r, t) {
    return r ? x(t) : e ? "dark" === t ? d.elements.primary.ondark.value : d.elements.primary.onlight.value : "dark" === t ? d.elements.secondary.ondark.value : d.elements.secondary.onlight.value;
  },
  I = function I(e, r) {
    return e || r ? 0 : t(1);
  },
  D = function D(e, r) {
    return e ? x(r) : "dark" === r ? d.elements.primary.ondark.value : d.elements.primary.onlight.value;
  },
  S = h.div.withConfig({
    displayName: "ComponentWrapper",
    componentId: "VDS__sc-jpysng-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  align-items: flex-start;\n  cursor: pointer;\n  position: relative;\n  margin: 0;\n  padding: 0 0 0 ", ";\n  -webkit-tap-highlight-color: transparent;\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), k, function (_ref) {
    var e = _ref.surface,
      r = _ref.disabled,
      t = _ref.selected,
      o = _ref.$error,
      n = _ref.$isMobileDevice;
    return !r && "\n      .radioOuter {\n        border: solid ".concat(l.border.width.value, " ").concat(function (e, r) {
      return e ? "dark" === r ? d.elements.primary.ondark.value : d.elements.primary.onlight.value : "dark" === r ? l.color.border.ondark.value : l.color.border.onlight.value;
    }(t, e), ";\n      }\n    \n      &:hover:not(:active)  .radioOuter {\n        border-color: ").concat(C(t, o, e), ";\n        box-shadow: 0 0 0 ").concat(I(t, n), " ").concat(C(t, o, e), ";\n      }\n  \n      &:active .radioOuter {\n        border-color: ").concat(D(o, e), ";\n      }\n  \n      &:active:hover .radioOuter {\n        box-shadow: 0 0 0 ").concat(I(t, n), " ").concat(D(o, e), ";\n      }\n    ");
  }, function (_ref2) {
    var e = _ref2.$error,
      r = _ref2.surface,
      t = _ref2.disabled;
    return e && !t && "\n      .radioOuter {\n        background-color: ".concat(function (e) {
      return "dark" === e ? d.feedback.error.background.ondark.value : d.feedback.error.background.onlight.value;
    }(r), ";\n        border-color: ").concat(x(r), ";\n        box-shadow: 'none';\n        }\n      ");
  }, function (_ref3) {
    var e = _ref3.disabled,
      r = _ref3.surface;
    return e && "\n      .radioOuter {\n        background: transparent;\n        border: solid ".concat(l.border.width.value, " ").concat("dark" === r ? m : b, ";\n      }\n    ");
  }),
  F = h.input.withConfig({
    displayName: "StyledInput",
    componentId: "VDS__sc-jpysng-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  opacity: 0;\n  margin: 0;\n  overflow: hidden;\n  padding: 0;\n  border: 0;\n  white-space: nowrap;\n  top: -", "px;\n  width: ", "px;\n  height: ", "px;\n  right: calc(100% - ", ");\n  cursor: ", ";\n  pointer-events: auto;\n\n  ", ";\n"])), 12, 44, 44, k, function (_ref4) {
    var e = _ref4.disabled;
    return e ? "default" : "pointer";
  }, function (_ref5) {
    var e = _ref5.$showFocus,
      r = _ref5.surface;
    return e && "\n        &:focus:not(:hover) + label .radioOuter::after {\n          border-radius: 50%;\n          display: block;\n          border: ".concat(t($), " ").concat(y, "\n            ").concat("dark" === r ? d.elements.primary.ondark.value : d.elements.primary.onlight.value, ";\n          content: '';\n          height: ").concat(w, ";\n          left: 50%;\n          position: absolute;\n          top: 50%;\n          transform: translate(-50%, -50%);\n          width: ").concat(w, ";\n        };\n    ");
  });
var O = /*#__PURE__*/function (_p) {
  _inherits(O, _p);
  function O(e) {
    var _this;
    _classCallCheck(this, O);
    var r;
    _this = _possibleConstructorReturn(this, _getPrototypeOf(O).call(this, e)), r = _assertThisInitialized(_assertThisInitialized(_this)), _this._onChange = function (e) {
      var t, o;
      var n = r.state.hovered;
      n ? r.setState({
        showFocus: !1
      }) : r.setState({
        showFocus: !0
      }), r.isControlled ? null === (o = (t = r.props).onChange) || void 0 === o || o.call(t, e) : r.setState(function (e) {
        return {
          selected: !e.selected
        };
      });
    }, _this.onKeyDown = function (e) {
      "Enter" === e.key && r._onChange(e);
    }, _this._blurOnClick = function (e) {
      e.stopPropagation(), "change" === r.props.errorEvent && v(e, r);
    }, _this._onBlur = function (e) {
      "blur" === r.props.errorEvent && v(e, r);
    }, _this._addHover = function (e) {
      r.state.hovered || r.setState({
        hovered: !0
      });
    }, _this._removeHover = function (e) {
      return r.setState({
        hovered: !1
      });
    }, _this._onFocus = function (e) {
      r.state.hovered ? r.setState({
        showFocus: !1
      }) : r.setState({
        showFocus: !0
      });
    }, _this.state = {
      selected: _this.props.selected || !1,
      showFocus: !0
    };
    return _this;
  }
  _createClass(O, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.isControlled = void 0 !== this.props.selected, this.isMobileDevice = n() || !1, this.radioId = this.props.inputId ? this.props.inputId : a();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(e) {
      e && e.selected !== this.props.selected && this.setState(function () {
        return {
          selected: !e.selected
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        t = _this$props.children,
        o = _this$props.label,
        n = _this$props.disabled,
        a = _this$props.error,
        s = _this$props.name,
        d = _this$props.value,
        l = _this$props.ariaLabel,
        c = _this$props.surface,
        u = _this$props.tabIndex,
        p = _this$props.inputRef,
        h = _this$props.ariaDescribedBy,
        v = _this$props["data-analyticstrack"],
        b = _this$props["data-track"],
        m = _this$props["data-track-ignore"],
        k = _this$props["data-clickstream"],
        g = _this$props.id,
        _this$state = this.state,
        $ = _this$state.selected,
        y = _this$state.error;
      return e(S, {
        surface: c,
        disabled: n,
        $error: !$ && (y || "boolean" == typeof a && a),
        selected: $,
        onMouseEnter: this._addHover,
        onMouseLeave: this._removeHover,
        $isMobileDevice: this.isMobileDevice,
        className: "radioWrapper",
        id: g,
        children: [r(F, {
          checked: $,
          disabled: n,
          id: this.radioId,
          name: s,
          onBlur: this._onBlur,
          onChange: this._onChange,
          onKeyDown: this.onKeyDown,
          onClick: this._blurOnClick,
          role: "radio",
          type: "radio",
          value: d,
          $showFocus: this.state.showFocus,
          onFocus: this._onFocus,
          surface: c,
          tabIndex: u,
          ref: p,
          "aria-describedby": h,
          "aria-label": l || (o ? "".concat(i(o), " ").concat(i(t)) : i(t))
        }), r(f, {
          disabled: n,
          selected: $,
          $radioId: this.radioId,
          label: o,
          "data-track": b,
          "data-track-ignore": m,
          "data-analyticstrack": v,
          "data-clickstream": k,
          surface: c,
          $calculateLetterSpacing: _,
          children: t
        })]
      });
    }
  }]);
  return O;
}(p);
O.defaultProps = {
  selected: void 0,
  children: "",
  disabled: !1,
  error: void 0,
  errorEvent: "blur",
  surface: "light"
};
var M = o(O);
export { M as default };